// Lines and Lyrics — The Music Gauntlet card deck. Add new cards from JSON exports here.
export const linesAndLyricsCards = [
  {
    cardId: 'die-with-a-smile',
    header: { title: 'LINES AND LYRICS', subtitle: 'THE MUSIC GAUNTLET', prompt: 'NAME THAT SONG' },
    clues: [
      { slot: 1, label: 'WORD 1', actor: 'Bruce Willis', movie: 'Die Hard with a Vengeance', answer: 'DIE' },
      { slot: 2, label: 'WORD 2', actor: 'Clark Gable', movie: 'Gone with the Wind', answer: 'WITH' },
      { slot: 3, label: 'WORD 3', actor: 'Jack Nicholson', movie: 'A Few Good Men', answer: 'A' },
      { slot: 4, label: 'WORD 4', actor: 'Julia Roberts', movie: 'Mona Lisa Smile', answer: 'SMILE' },
    ],
    artists: ['Lady Gaga', 'Bruno Mars'],
    answer: { title: 'Die With A Smile', performedBy: ['Lady Gaga', 'Bruno Mars'] },
  },
];
